/*
 * @providesModule FraudPromptNavigator
 *
 */
import ModalNavigationController, {ModalProps} from 'ModalNavigationController';
import SkillzRouter from 'SkillzRouter';

export default class FraudPromptNavigator {
  static pushComponentWithScene(component: React.ReactNode) {
    ModalNavigationController.hideModal(() => {
      ModalNavigationController.showModal(
        component,
        {animationType: 'slide', transparent: false},
        'FraudPromptAlert'
      );
    }, 'FraudPromptAlert');
  }
  static popNavigatorToRoot() {
    ModalNavigationController.hideModal(undefined, 'FraudPromptAlert');
    SkillzRouter.backToRoot();
  }
  static showModal(component: React.ReactNode, modalProps: ModalProps) {
    ModalNavigationController.showModal(component, modalProps);
  }
  static hideModal() {
    ModalNavigationController.hideModal();
  }
}
